import { api as auth0Api } from 'app/utils/auth0_handler';

export function getAuthToken() {
  return auth0Api.getChannel().request('get:instance').getAuthToken();
}
